<nav class="navbar sticky-top bg-white header">
  <div class="container-fluid">
    <div class="row m-0">
      <div class="col col-4 col-lg-5 col-md-4 align-self-center d-inline-flex p-0">
        <a class="navbar-brand">
          <img (click)="openNewTab()" src="assets/icons/logo.png" alt="c¡nch" class="navbar-brand logo" />
        </a>
      </div>
      <div class="col col-6 align-self-center right p-0" *ngIf="">
        <div class="row m-0">
          <div class="col right p-0">
            <span class="sign-in" (click)="signIn()">
              Sign In
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>